import { Popover } from '@material-ui/core';
import { get } from 'lodash';
import React from 'react';
import { copyProps } from 'util/misc';
import SubOptionForm from '../SubOptionForm';
import { subOptionFormAvailable } from '../SubOptionForm';

const SubOptionPopover = ({
  open,
  row,
  rowState,
  column,
  selectedType,
  anchorElement,
  handleChange,
  setOpen,
  origin,
}) => {
  const [selectedOption, setSelectedOption] = React.useState(
    column.options[selectedType] || {}
  );

  React.useEffect(() => {
    setSelectedOption(column.options[selectedType] || {});
  }, [selectedType]);

  const setOptionChange = (value, index) => {
    let tempValueSet = [
      ...(rowState[selectedOption.key] ||
        selectedOption[selectedOption.key] ||
        []),
    ];
    tempValueSet[index] = value;
    handleChange(tempValueSet);
  };

  const removeItem = (index) => {
    handleChange([
      ...(
        rowState[selectedOption.key] ||
        selectedOption[selectedOption.key] ||
        []
      ).filter((item, itemIndex) => itemIndex !== index),
    ]);
  };

  return (
    <Popover
      anchorEl={anchorElement}
      anchorOrigin={
        origin || {
          vertical: 'top',
          horizontal: 'center',
        }
      }
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      open={subOptionFormAvailable.includes(rowState[column.key]) && open}
      onClose={() => {
        setOpen(false);
      }}
      PaperProps={{
        style: {
          padding: 20,
          minWidth: 200,
          maxWidth: 600,
          boxShadow: '0px 20px 80px #00000011',
        },
      }}
    >
      <SubOptionForm
        horizontal
        row={row}
        column={column}
        handleChange={handleChange}
        rowState={rowState}
        selectedOption={selectedOption}
        content={
          rowState[selectedOption.key] || selectedOption[selectedOption.key]
        }
        removeItem={removeItem}
        onChange={setOptionChange}
      />
    </Popover>
  );
};

export default SubOptionPopover;
